module.exports = __webpack_public_path__ + "static/sponsor_rectangle-f89c0c5865e70563ce5bd6906178711c.svg";